import React from 'react';
import { Navigate, Outlet, RouteObject } from 'react-router';

import { permissions } from './permissions';
import { PermissionGuard } from '~/core/PermissionGuard';
import { Route as CreditFacilityBorrowingBaseConfigurationRoute } from '~/core/routes/settings/credit-facilities/[creditFacilityId]/borrowing-base/configuration/_index';
import { Route as CreditFacilityBorrowingBaseLoanTapeRoute } from '~/core/routes/settings/credit-facilities/[creditFacilityId]/borrowing-base/loantape/_index';
import { Route as CreditFacilityPortfolioCovenantsConfigurationRoute } from '~/core/routes/settings/credit-facilities/[creditFacilityId]/portfolio-covenants/configuation/_index';
import { Route as CreditFacilityPortfolioCovenantsEditRoute } from '~/core/routes/settings/credit-facilities/[creditFacilityId]/portfolio-covenants/edit/_index';
import { Route as CreditFacilitiesRoute } from '~/core/routes/settings/credit-facilities/_index';
import { SettingsViewTemplate } from '~/core/routes/settings/SettingsTemplate';

// Exports
export const Router: RouteObject = {
  element: (
    <PermissionGuard
      permissions={permissions}
      fallback={<Navigate to="/settings" replace />}
    >
      <Outlet />
    </PermissionGuard>
  ),
  // Relative to /settings/credit-facilities/*
  children: [
    {
      index: true,
      element: (
        <SettingsViewTemplate>
          <CreditFacilitiesRoute />
        </SettingsViewTemplate>
      ),
    },
    {
      path: ':creditFacilityId/borrowing-base/configuration',
      element: <CreditFacilityBorrowingBaseConfigurationRoute />,
    },
    {
      path: ':creditFacilityId/borrowing-base/loantape',
      element: <CreditFacilityBorrowingBaseLoanTapeRoute />,
    },
    {
      path: ':creditFacilityId/portfolio-covenants/configuration',
      element: <CreditFacilityPortfolioCovenantsConfigurationRoute />,
    },
    {
      path: ':creditFacilityId/portfolio-covenants/edit',
      element: <CreditFacilityPortfolioCovenantsEditRoute />,
    },
  ],
};
